import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";

const Container = tw.div`relative bg-white`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;

const TextColumn = styled(Column)(props => [
  tw`md:w-6/12 mt-8 md:mt-0 md:pr-8 lg:pr-16 md:order-first`,
]);

const MapColumn = tw(Column)`md:w-6/12 lg:w-5/12 flex-shrink-0 h-96 md:h-auto md:order-last rounded-4xl overflow-hidden shadow-lg`;

const Iframe = tw.iframe`w-full h-full border-0 rounded-4xl`;

const TextContent = tw.div`lg:py-8`;
const Subheading = tw(SubheadingBase)`text-center md:text-left text-[#3F62A3]`;
const Heading = tw(
  SectionHeading
)`text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight text-black`;
const Description = tw.p`text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-black mt-4`;

const Statistics = tw.div`mt-6 lg:mt-8 xl:mt-16 flex flex-wrap`;
const Statistic = tw.div`text-lg sm:text-2xl lg:text-3xl w-1/2 mt-4 lg:mt-10 text-center md:text-left`;
const Value = tw.div`font-bold text-[#3F62A3]`;
const Key = tw.div`font-medium text-[#002952]`;

export default ({ textOnLeft = true }) => {
  const statistics = [
    { key: "Provincies", value: "12" },
    { key: "Steden", value: "355" },
  ];

  return (
    <Container>
      <TwoColumn>
        <TextColumn>
          <TextContent>
            <Subheading>Onze dekking in Nederland</Subheading>
            <Heading>
              <span className="text-[#3F62A3]">Safety Locks</span>{" "}
              <span className="text-[#002952]">door heel Nederland.</span>
            </Heading>
            <Description>
              <span className="font-bold text-[#3F62A3]">Safety Locks</span> is actief in alle regio’s van Nederland. 
              Of je nu in een drukke stad woont of in een rustige woonwijk, onze gecertificeerde slotenmakers staan 
              altijd voor je klaar. We bieden betrouwbare hulp bij buitensluitingen, het vervangen van sloten en 
              de installatie van driepuntssluitingen.
              <br />
              <br />
              Dankzij onze landelijke dekking en snelle responstijd kun je altijd rekenen op een veilige en 
              professionele service, waar je ook bent.
            </Description>
            <Statistics>
              {statistics.map((stat, index) => (
                <Statistic key={index}>
                  <Value>{stat.value}</Value>
                  <Key>{stat.key}</Key>
                </Statistic>
              ))}
            </Statistics>
          </TextContent>
        </TextColumn>

        <MapColumn>
          <Iframe
            title="Safety Locks Nederland"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067734.9028297365!2d3.1953784295745483!3d52.29584526540781!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c5fb5a9510b0f7%3A0xbadf0bbf9af4e2cb!2sNederland!5e0!3m2!1snl!2snl!4v1695927723495!5m2!1snl!2snl"
          />
        </MapColumn>
      </TwoColumn>
    </Container>
  );
};
